$(function() {
  if($('.product-purchase-form').length) {
    var button = $('.quantity-submit-row');
    $(window).scroll(function() {
      if ($(window).width() < 769) {
        var scroll = $(window).scrollTop();
    
        if (scroll >= $('.product-purchase-form').offset().top) { 
          button.addClass('stick');
        } else { 
          button.removeClass('stick');
        }
      }
    });
  }
});

$(document).ready(function() {
  
  /* custom mega menu */
  $(".with-products .navigation__link").on("mouseover", function () {
    $(".with-products .navigation__link").removeClass('active');
    $(this).addClass('active');
  
    var title = $(this).attr('data-menu-title');
    $(".menu_products").removeClass('active');
    $('.menu_products[data-menu="'+title+'"]').addClass('active');
  });
  /* custom mega menu */


  /* custom nutrition images */
  $('.nutrition-thumbs li button').on("click", function (e) {
    e.preventDefault();
    $(".nutrition-thumbs li button").removeClass('active');
    $(this).addClass('active');
    
    var image = $(this).attr('data-index');
    $('.nutrition-slideshow').slick('slickGoTo', image - 1);
  });
  /* custom nutrition images */

  if($('.faq-index__sticky-container').length) {
    setTimeout(function() { 
      $('#content .container .section-faq-header--with-index .faq-header .faq-index .faq-index__sticky-container .faq-index__item-container .faq-index-item:first .faq-index-item__link').addClass('active');
      $('#content .container .section-collapsible-tabs:first .cc-accordion').addClass('active');
    }, 1000);
  }

  /* bundle pages */
  if($('.custom-bundle-wrap').length) {
    var ctr = 0;
    var limit = parseInt($('.custom-bundle-wrap').attr('data-limit'));

    if($('.section-featured-product-bundle').length) {
      $('.opt-btn').on('change', function() {
        ctr = 0;
        limit = parseInt($(this).attr('data-count'));
        $('.custom-bundle-wrap').attr('data-limit', limit);

        $('.product-chosen-item').removeClass('hidden');
        $('.product-chosen-item').each(function(e){
          if(parseInt($(this).attr('data-index')) > limit) {
            $(this).addClass('hidden');
          }
        });

        $('.product-purchase-form .flavors').each(function(e){
          $(this).val("");
        });

        $('.product-chosen .product-chosen-item').each(function(e){ 
          $(this).addClass('empty-item');
          $(this).children('.not-empty').hide();
        });

        $('.quantity-wrapper input[name="quantity"]').val(1);
        $('.quantity-wrapper').hide();
        $('.btn_add_to_cart').show();

        $('.btn_add_to_cart:not(.btn-sold-out)').prop('disabled', false);
        $('.btn-add-all').prop('disabled', true);
        if (limit == 1) {
          $('#add_text').text("Pick "+limit+" More Box");
        } else {
          $('#add_text').text("Pick "+limit+" More Boxes");
        }
        
        
      });
    }

    $('.btn-add-all').prop('disabled', true);
    if($('.section-featured-product-bundle').length) {
      $('.btn-add-all').html('<span id="add_text">Pick <span id="add_ctr">'+limit+'</span> More Boxes</span>');
    } else {
      $('.btn-add-all').html('<span id="add_text">Pick <span id="add_ctr">'+limit+'</span> More Bags</span>');
    }
    

    $('body').on('click', '.btn_add_to_cart', function(){
      $(this).hide();
      $(this).next().show();
      ctr = ctr + 1;

      const img = $(this).attr('data-img');
      const prod_id = $(this).attr('data-id');
      const flavor = $(this).attr('data-flavor');

      $('.product-purchase-form .flavors').each(function(e){
        if($(this).val() == '') {
          $(this).val(flavor);
          return false;
        }
      });

      addToCartText(ctr,limit);
      replaceImage(img, prod_id, flavor);

    });


    $('body').on('click', '.remove-product', function(e){
      e.preventDefault();

      const prod_id = $(this).parent().attr('data-product');
      const index = $(this).parent().attr('data-index');
      const flavor = $(this).parent().attr('data-flavor');

      const elem = $('.btn_add_to_cart[data-id="'+prod_id+'"]').next().children('input');
      const qty_now = parseInt(elem.val());
      if (qty_now == 1) {
        elem.parent().hide();
        elem.parent().prev().show();
      } else {
        elem.val(qty_now-1);
      }
      ctr = ctr - 1;
      addToCartText(ctr,limit);

      $('.product-purchase-form .flavors').each(function(e){
        if($(this).val() == flavor) {
          $(this).val("");
          return false;
        }
      });

      const prod_item = $(this).parent();
      prod_item.children('.not-empty').attr("src", "");
      prod_item.children('.not-empty').hide();
      prod_item.addClass('empty-item');
      prod_item.children('.empty').show();
    });

    
    $('body').on('click', '.minus', function(){
      const qty = parseInt($(this).next().val());
      const new_qty = qty - 1;
      if (new_qty < 1) {
        $(this).parent().hide();
        $(this).parent().prev().show();
        ctr = ctr - 1;
        addToCartText(ctr,limit);
      } else {
        $(this).next().val(new_qty);
        ctr = ctr - 1;
        addToCartText(ctr,limit);
      }

      const flavor = $(this).parent().prev().attr('data-flavor');
      $('.product-purchase-form .flavors').each(function(e){
        if($(this).val() == flavor) {
          $(this).val("");
          return false;
        }
      });
      
      const prod_id = $(this).parent().prev().attr('data-id');
      $('.product-chosen .product-chosen-item').each(function(e){
        if($(this).attr('data-product') == prod_id && $(this).hasClass('empty-item') == false) {
          $(this).children('.not-empty').attr("src", "");
          $(this).children('.not-empty').hide();
          $(this).addClass('empty-item');
          $(this).children('.empty').show();
    
          return false;
        }
      });
    });

    
    $('body').on('click', '.plus', function(){
      const qty = parseInt($(this).prev().val());
      const new_qty = qty + 1;
      if (new_qty <= limit) {
        $(this).prev().val(new_qty);
        ctr = ctr + 1;
        addToCartText(ctr,limit);

        const img = $(this).parent().prev().attr('data-img');
        const prod_id = $(this).parent().prev().attr('data-id');
        const flavor = $(this).parent().prev().attr('data-flavor');
        replaceImage(img, prod_id, flavor);

        $('.product-purchase-form .flavors').each(function(e){
          if($(this).val() == '') {
            $(this).val(flavor);
            return false;
          }
        });
      }
    });
  }
  /* bundle pages */

  
});

// if ($('body').hasClass('template-suffix-variety-pack-product')) {
//   $(document).scroll(function () {
//       var y = $(this).scrollTop();
//     console.log('y', y);
//       if (y > 100) {
//         $('#shopify-section-announcement-bar').fadeOut();
//         $('#shopify-section-header .pageheader').fadeOut();
//       } else {
//         $('#shopify-section-announcement-bar').fadeIn();
//         $('#shopify-section-header .pageheader').fadeIn();
//       }
//   });
// }

function replaceImage(image, id, product) {
  $('.product-chosen .product-chosen-item').each(function(e){ 
    if($(this).hasClass('empty-item')) {
      $(this).attr('data-product', id);
      $(this).attr('data-flavor', product);
      $(this).children('.not-empty').show();
      $(this).children('.not-empty').attr("src", image);
      $(this).removeClass('empty-item');
      $(this).children('.empty').hide();

      return false;
    }
  });
}

function addToCartText(counter, maximum) {
  if (counter == maximum) {
    $('.btn_add_to_cart:not(.btn-sold-out)').prop('disabled', true);
    $('#add_text').text("Add to Cart");
    $('.btn-add-all').removeAttr('disabled');

    $('button.plus').prop('disabled', true);
  } else {
    $('.btn_add_to_cart:not(.btn-sold-out)').prop('disabled', false);
    $('.btn-add-all').prop('disabled', true);

    $('button.plus').prop('disabled', false);
    
    if(maximum-counter == 1) {
      if($('.section-featured-product-bundle').length) {
        $('#add_text').text("Pick 1 More Box");
      } else {
        $('#add_text').text("Pick 1 More Bag");
      }
    } else {
      if($('.section-featured-product-bundle').length) {
        $('#add_text').text("Pick "+(maximum-counter)+" More Boxes");
      } else {
        $('#add_text').text("Pick "+(maximum-counter)+" More Bags");
      }
    }
  }
}

